// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","resumePhoneFormColumn":"eQW03lMuOeXo8jVMRfoYz"};